<!-- Fastpass 2 skip imaging step -->
<!-- @if (state() === CompatibilityState.Pms || state() === CompatibilityState.Imaging) {
  <div class="mx-auto mt-6 flex w-[184px] gap-1 rounded-full border border-background-disabled p-1">
    <div
      class="h-[6px] w-1/2 rounded-full"
      [ngClass]="{
        'bg-primary-blue': state() === CompatibilityState.Pms,
        'bg-background-disabled': state() === CompatibilityState.Imaging
      }"
    ></div>
    <div
      class="h-[6px] w-1/2 rounded-full"
      [ngClass]="{
        'bg-primary-blue': state() === CompatibilityState.Imaging,
        'bg-background-disabled': state() === CompatibilityState.Pms
      }"
    ></div>
  </div>
} -->

<div class="flex h-full flex-col items-center justify-center">
  @if (state() === CompatibilityState.Loading) {
    <ng-lottie [options]="lottieOptions" currentColor class="text-primary-blue"></ng-lottie>
  }
  @if (state() === CompatibilityState.Initial) {
    <h1 class="mb-10 text-center text-h1 font-semibold">
      {{ 'site_install_compatibility_title' | translate }}
    </h1>

    <h4 class="typo-h4-thin mb-2 text-center text-text-secondary">
      {{ 'site_install_compatibility_description1' | translate }}
    </h4>
    <h4 class="typo-h4-semibold mb-10 text-center text-text-secondary">
      {{ 'site_install_compatibility_description2' | translate }}
    </h4>
    <button class="btn-primary h-10" type="button" (click)="onStateChange(CompatibilityState.Pms)">
      {{ 'site_install_compatibility_button' | translate }}

      <svg-icon key="px-24-arrow-right" size="sm"></svg-icon>
    </button>
  }

  <form class="flex w-full flex-col items-center xs:w-[440px]" [formGroup]="compatibilityForm">
    @if (state() === CompatibilityState.Pms) {
      <h1 class="mb-10 whitespace-pre-wrap text-center text-h1 font-semibold">
        {{ 'site_install_compatibility_pms_question' | translate }}
      </h1>
      <lib-dropdown
        background="white"
        [placeholder]="'site_install_compatibility_dropdown_placeholder' | translate"
        size="large"
        [options]="vm().tools?.data?.pms ?? []"
        formControlName="pms"
        class="w-full"
        [hint]="
          isPmsNextClicked && compatibilityForm.controls.pms.invalid ? ('site_install_compatibility_required_dropdown' | translate) : ''
        "
        [error]="isPmsNextClicked && compatibilityForm.controls.pms.invalid"
      ></lib-dropdown>

      @if (compatibilityForm.controls.pms.value === PmsPreference.OTHER) {
        <lib-input
          background="white"
          [placeholder]="'site_install_compatibility_pms_other_placeholder' | translate"
          size="large"
          formControlName="pmsOther"
          class="mt-4 w-full"
          [hint]="
            isPmsNextClicked && compatibilityForm.controls.pmsOther.invalid ? ('site_install_compatibility_required_text' | translate) : ''
          "
          [state]="isPmsNextClicked && compatibilityForm.controls.pmsOther.invalid ? 'error' : 'normal'"
        ></lib-input>
      }
      <button
        class="btn-primary mb-3 mt-10 h-10 w-full justify-center xs:w-auto xs:px-20"
        type="button"
        (click)="onPmsNextClick()"
        [disabled]="vm().siteInstallRequirements?.state === DataState.Loading"
      >
        @if (vm().siteInstallRequirements?.state === DataState.Loading) {
          <ng-lottie [options]="lottieOptions"></ng-lottie>
        }
        {{ 'site_install_compatibility_next_button' | translate }}
      </button>
      <button class="btn-text h-10" type="button" (click)="onStateChange(CompatibilityState.Initial)">
        {{ 'site_install_compatibility_back_button' | translate }}
      </button>
    }
    <!-- Fastpass 2 skip the imaging step -->
    <!-- @if (state() === CompatibilityState.Imaging) {
      <h1 class="mb-10 whitespace-pre-wrap text-center text-h1 font-semibold">
        {{ 'site_install_compatibility_imaging_question' | translate }}
      </h1>

      <lib-dropdown
        background="white"
        [placeholder]="'site_install_compatibility_dropdown_placeholder' | translate"
        size="large"
        [options]="vm().tools?.data?.imaging ?? []"
        formControlName="imaging"
        class="w-full"
        [hint]="
          isSubmitClicked && compatibilityForm.controls.imaging.invalid ? ('site_install_compatibility_required_dropdown' | translate) : ''
        "
        [error]="isSubmitClicked && compatibilityForm.controls.imaging.invalid"
      ></lib-dropdown>

      @if (compatibilityForm.controls.imaging.value === ImagingPreference.OTHER) {
        <lib-input
          background="white"
          [placeholder]="'site_install_compatibility_pms_other_placeholder' | translate"
          size="large"
          formControlName="imagingOther"
          class="mt-4 w-full"
          [hint]="
            isSubmitClicked && compatibilityForm.controls.imagingOther.invalid
              ? ('site_install_compatibility_required_text' | translate)
              : ''
          "
          [state]="isSubmitClicked && compatibilityForm.controls.imagingOther.invalid ? 'error' : 'normal'"
        ></lib-input>
      }

      <button class="btn-primary mb-3 mt-10 h-10 px-20" type="button" (click)="onSubmit()">
        {{ 'site_install_compatibility_next_button' | translate }}
      </button>

      <button class="btn-text h-10" type="button" (click)="onStateChange(CompatibilityState.Pms)">
        {{ 'site_install_compatibility_back_button' | translate }}
      </button>
    } -->
  </form>

  @if (state() === CompatibilityState.Conclusion) {
    @if (vm().siteInstallRequirements?.state === DataState.Loading) {
      <ng-lottie [options]="lottieOptions"></ng-lottie>
    } @else {
      @if (!vm().siteInstallRequirements?.data?.pmsAccepted) {
        <h1 class="mb-14 text-center text-h1 font-semibold">
          {{ 'site_install_compatibility_success_unhappy_title' | translate }}
        </h1>
        <h4 class="typo-h4-thin mb-14 max-w-[440px] whitespace-pre-wrap text-center text-text-primary">
          {{ 'site_install_compatibility_success_unhappy_description' | translate }}
        </h4>
        <button class="btn-primary mb-3 h-10 w-full justify-center px-6 xs:w-auto" type="button" (click)="onGoToShowCase()">
          {{ 'site_install_compatibility_success_unhappy_button' | translate }}
        </button>
        <!-- @if (!vm().contract?.data) {
          <button class="btn-text h-10" type="button" (click)="onStateChange(CompatibilityState.Initial)">
            {{ 'site_install_compatibility_success_change_button' | translate }}
          </button>
        } -->
      } @else {
        <h1 class="mb-14 text-center text-h1 font-semibold text-text-primary">
          {{ 'site_install_compatibility_success_happy_title' | translate }}
        </h1>
        <h4 class="typo-h4-thin mb-14 max-w-[440px] whitespace-pre-wrap text-center text-text-primary">
          {{
            (vm().siteInstallRequirements?.data?.imagingAccepted
              ? 'site_install_compatibility_success_happy_description'
              : 'site_install_compatibility_success_semi_happy_description'
            ) | translate
          }}
        </h4>
        <button class="btn-primary mb-3 h-10 w-full justify-center xs:w-auto xs:px-20" type="button" (click)="onStart()">
          {{ 'site_install_compatibility_success_happy_button' | translate }}
        </button>
        <!-- @if (!vm().contract?.data) {
          <button class="btn-text h-10" type="button" (click)="onStateChange(CompatibilityState.Initial)">
            {{ 'site_install_compatibility_success_change_button' | translate }}
          </button>
        } -->
      }
    }
  }
</div>
